<template>
  <div id="app" ref="app" class="notranslate" translate="no">
    <loading v-if="$store.state.isLoadingActive"></loading>
    <router-view></router-view>
  </div>
</template>

<script>
import i18n from "./i18n";
import loading from "@/components/reusable/Loading";
export default {
  name: "app",
  components: { loading },
  mounted() {
    // check if iOS and add class 'ios-touch' to resolve :hover problems on iOS
    if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
      this.$refs.app.classList.add("ios-touch");
    }
    this.$store.dispatch("detectWebView");
  },
  watch: {
    template(newVal) {
        if (newVal) {
          const surveyIso = this.template.survey.iso3 && this.template.survey.iso3.toUpperCase();

          if(surveyIso && ['COL', 'PER'].includes(surveyIso)){
            i18n.changeLanguage('es')
            this.applyDocumentLanguage('es')
          } else if (surveyIso === 'FRA') {
            i18n.changeLanguage('fr')
            this.applyDocumentLanguage('fr')
          } else {
            this.applyDocumentLanguage('pt-BR')
          }
        }
    }
  },
  computed: {
    template() {
      return this.$store.state.template;
    }
  },
  methods: {
    applyDocumentLanguage(lang) {
      document.documentElement.lang = lang;
      document.documentElement.classList.add("notranslate");
      document.documentElement.setAttribute("translate", "no");

      let meta = document.querySelector('meta[name="google"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "google");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", "notranslate");
    }
  }
};
</script>

<style lang="scss">
@import "./assets/scss/style.scss";
</style>
